import { type ReactNode } from 'react'

import { useBanner } from '~/hooks/useBanner'
import { useIsMobile } from '~/utils/devices'
import { cn } from '~/utils/tailwind-utils'

export const PageLayoutTopBar = ({
  secondaryButtons,
  breadcrumbs,
}: {
  secondaryButtons?: ReactNode
  breadcrumbs?: ReactNode
}) => {
  const isMobile = useIsMobile()
  const { showBanner } = useBanner()

  if (isMobile) return null

  if (!secondaryButtons && !breadcrumbs) return <div className="h-[60px]" />

  return (
    <div
      className={cn(
        'sticky z-20 flex w-full items-center justify-between bg-white p-3 dark:bg-black',
        showBanner ? 'top-10' : 'top-0',
      )}
    >
      <div className="flex items-center gap-2">{breadcrumbs}</div>
      <div className="flex items-center gap-2">{secondaryButtons}</div>
    </div>
  )
}
